<ng-container *ngIf="viewModel$ | async as vm">

  <!-- Popup date picker with availability rings + tier colours -->
  <div class="calc-date-picker-row">
    <p-calendar
      class="calc-date-input"
      selectionMode="single"
      [ngModel]="vm.selectedDate"
      (ngModelChange)="onDateSelected($event)"
      (onMonthChange)="onMonthChanged($event)"
      [showIcon]="true"
      [readonlyInput]="true"
      dateFormat="D, M d"
      [appHighlightDates]="vm.highlightDates"
    />
  </div>

  <!-- Availability card + discount button — shown when a date is selected -->
  <ng-container *ngIf="vm.timelineDates.length">

    <app-availability-date
      *ngFor="let date of vm.timelineDates"
      [date]="date"
      [showTier]="false"
    ></app-availability-date>

    <!-- Ask for Discount button (immediate click) -->
    <button
      type="button"
      *ngIf="holdState === 'idle'"
      class="hold-btn"
      (click)="askForDiscount()"
    >
      <span class="hold-btn-label">
        Ask for Discount
      </span>
    </button>

    <!-- Applied: discount confirmed — shows current applied %, Reset button -->
    <div *ngIf="holdState === 'applied'" class="hold-applied">
      <span class="hold-applied-label">
        <i class="pi pi-check-circle"></i>
        {{ appliedTierName }} {{ appliedTierPercent }}% Applied
      </span>
      <button type="button" class="hold-reset-btn" (click)="resetDiscount()">
        <i class="pi pi-refresh"></i> Reset
      </button>
    </div>

  </ng-container>
</ng-container>

<!-- ── Discount Options Dialog ── -->
<p-dialog
  header="Discount Options"
  [(visible)]="showSuggestionDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '24rem', 'max-width': '95vw' }"
  (onHide)="onDialogHide()"
>
  <div class="suggestion-list">
    <!-- Current date card at top -->
    <div *ngIf="currentDayInfo" class="suggestion-card current-date-card" [style.--tier-color]="currentDayInfo.tierColor">
      <div class="suggestion-card-left">
        <span class="suggestion-card-date">{{ currentDayInfo.formattedDate }}</span>
        <span class="suggestion-card-tier">{{ currentDayInfo.tierName }}</span>
      </div>
      <div class="suggestion-card-right">
        <span class="suggestion-card-pct">{{ currentDayInfo.tierPercent }}%</span>
      </div>
    </div>

    <!-- Divider showing "nearby dates" -->
    <div *ngIf="suggestionDays.length > 0" class="suggestion-divider">
      <span class="suggestion-divider-label">Nearby dates</span>
    </div>

    <!-- Nearby date suggestion cards -->
    <button
      type="button"
      *ngFor="let day of suggestionDays"
      class="suggestion-card"
      [style.--tier-color]="day.tierColor"
      (click)="onSuggestionDatePicked(day)"
    >
      <div class="suggestion-card-left">
        <span class="suggestion-card-date">{{ day.formattedDate }}</span>
        <span class="suggestion-card-tier">{{ day.tierName }}</span>
      </div>
      <div class="suggestion-card-right">
        <span class="suggestion-card-pct">{{ day.tierPercent }}%</span>
        <i class="pi pi-arrow-right suggestion-card-arrow"></i>
      </div>
    </button>
  </div>

  <ng-template pTemplate="footer">
    <button
      type="button"
      *ngIf="currentDayInfo && currentDayInfo.tierPercent < 0"
      pButton
      [label]="'Apply ' + currentDayInfo.tierPercent + '% to current date'"
      severity="success"
      [text]="true"
      (click)="applyDiscountFromDialog(currentDayInfo)"
    ></button>
    <button
      type="button"
      pButton
      label="Cancel"
      severity="secondary"
      [text]="true"
      (click)="onKeepCurrentDate()"
    ></button>
  </ng-template>
</p-dialog>